const navigationItems = [
  ["/admin", "Dashboard"],
  ["/admin/orders", "Orders"],
  ["/admin/menu-items", "Menu Items"],
  ["/admin/categories", "Categories"],
  ["/admin/weekly-menu", "Weekly Menu"],
  ["/admin/locations", "Locations"],
  ["/admin/catering", "Catering"],
  ["/admin/analytics", "Analytics"],
  ["/admin/settings", "Settings"],
];

function isActiveRoute(currentPath, itemPath) {
  if (itemPath === "/admin") {
    return currentPath === itemPath;
  }

  return currentPath.startsWith(itemPath);
}

export default function AdminSidebar({ currentPath, onNavigate }) {
  return (
    <aside className="admin-sidebar">
      <a
        className="admin-brand"
        href="/admin"
        onClick={(event) => {
          event.preventDefault();
          onNavigate("/admin");
        }}
      >
        Zayas Kitchen
      </a>

      <nav className="admin-nav" aria-label="Admin navigation">
        {navigationItems.map(([itemPath, label]) => {
          const active = isActiveRoute(currentPath, itemPath);

          return (
            <a
              key={itemPath}
              className={active ? "active" : ""}
              href={itemPath}
              onClick={(event) => {
                event.preventDefault();
                onNavigate(itemPath);
              }}
            >
              {label}
            </a>
          );
        })}
      </nav>
    </aside>
  );
}